export default __webpack_public_path__ + "static/media/1311.0bdf2945.png";